import ActionRenderer from './ActionRenderer';

export default ActionRenderer;
